/**
 * @class UnsavedModalController
 * @template M
 */
export class UnsavedModalController {

    static get SAVE_AND_CONTINUE() {
        return 'SAVE_AND_CONTINUE';
    }

    static get CONTINUE_WITHOUT_SAVING() {
        return 'CONTINUE_WITHOUT_SAVING';
    }

    static get bindings() {
        return {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    }

    saveAndContinue() {
        console.log('saved');
        this.close({$value: UnsavedModalController.SAVE_AND_CONTINUE});
    }

    continueWithoutSaving() {
        console.log('not saved');
        this.close({$value:UnsavedModalController.CONTINUE_WITHOUT_SAVING});
    }

    cancel() {
        this.dismiss({$value: 'cancel'});
    }
}

export const UnsavedModalComponent = {
    selector: 'unsavedModal',
    template: require('./unsaved-modal.component.html'),
    controller: UnsavedModalController,
    bindings: UnsavedModalController.bindings
};


// WEBPACK FOOTER //
// ./src/app/components/unsaved-modal/unsaved-modal.component.js